import React from 'react';
import CodeSnippet from './CodeSnippet';

function ScssMap({snippet, title, description}) {
	return (
		<div>
			<div className="rwx-split explicit align center-vertically">
				<div className="rwx-split-half">
					<p className="h6 rwxt-text-center">{title}</p>
					{
						description.map((d,i)=>
							<p key={`scss-map-${title.toLowerCase().replace(' ', '')}-${i}`}>{d}</p>
						)
					}
				</div>
				<div className="rwx-split-half">
					<CodeSnippet language="css" data={snippet} />
				</div>
			</div>
		</div>
	)
}

export default ScssMap;